'use strict';

import { offset } from '../utils/offset';
import { id } from '../utils/id';

export function Tooltip(params) {
    const tooltipId = id();

    const element = (function () {
        const element = document.createElement('div');
        element.setAttribute('role', 'tooltip');
        element.setAttribute('id', tooltipId);
        element.classList.add('tooltip', 'post');
        element.style.display = 'none';
        if (!!params && params.zIndex) {
            element.style.zIndex = params.zIndex;
        }
        return element;
    })();

    function show() {
        updatePosition(this);
        this.element.style.display = 'block';
        this.ctaElement.classList.add('active');
        this.element.classList.add('tooltip--shown');

        const _this = this;
        setTimeout(function () {
            _this.isShown = true;
        }, 500);
    }

    function hide() {
        this.element.style.display = 'none';
        this.ctaElement.classList.remove('active');
        this.element.classList.remove('tooltip--shown');
        this.isShown = false;
    }

    function init(ctaElement) {
        this.ctaElement = ctaElement;
        this.ctaElement.setAttribute('data-tooltip-id', tooltipId);
        this.element.innerHTML = this.ctaElement.dataset.tooltipContent;
        updatePosition(this);
        document.body.append(this.element);

        const _this = this;
        _this.ctaElement.addEventListener('click', function (event) {
            event.stopPropagation();
            _this.show();
        });

        _this.ctaElement.addEventListener('focus', function (event) {
            event.stopPropagation();
            _this.show();
        });

        _this.ctaElement.addEventListener('touchstart', function (event) {
            event.stopPropagation();
            _this.show();
        });

        _this.ctaElement.addEventListener('focusout', function (event) {
            event.stopPropagation();
            _this.hide();
        });

        setTimeout(function () {
            updatePosition(_this);
        }, 1000);

        window.addEventListener('resize', function (event) {
            updatePosition(_this);
        });

        if (!!params && params.modal) {
            params.modal.addEventListener('scroll', function (event) {
                updatePosition(_this);
            });
        }
    }

    function updatePosition(_this) {
        if(typeof _this === 'undefined') {
            _this = this;
        }
        
        const leftPosition = (offset(_this.ctaElement).left + _this.ctaElement.clientWidth);
        _this.element.style.left = (leftPosition + 320 < window.innerWidth) ? leftPosition + 'px' : 'initial';
        _this.element.style.right = (leftPosition + 320 > window.innerWidth) ? '0px' : 'initial';
        _this.element.style.top = (offset(_this.ctaElement).top + _this.ctaElement.clientHeight) + 'px';
    }

    return {
        element: element,
        isShown: false,
        ctaElement: null,
        init: init,
        show: show,
        hide: hide,
        updatePosition: updatePosition
    }
}
